/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IActionContext } from '@msdyn365-commerce/core';
import { Cart, CartsDataActions, CommerceException } from '@msdyn365-commerce/retail-proxy';

import { ICartActionResultWithCart } from './cart-action-result';

export default async function addInvoicesToCartInternal(
    cart: Readonly<Cart>,
    invoiceIds: string[],
    actionContext: IActionContext
): Promise<ICartActionResultWithCart> {
    if (!invoiceIds || invoiceIds.length === 0) {
        actionContext.telemetry.trace('Invoice ids are empty, unable to add invoices to cart.');
        return { cart, status: 'FAILED', substatus: 'EMPTYINPUT' };
    }

    if (cart.Version) {
        return CartsDataActions.addInvoicesAsync({ callerContext: actionContext }, cart.Id, invoiceIds)
            .then<ICartActionResultWithCart>(newCart => {
                return { cart: newCart, status: 'SUCCESS' };
            })
            .catch(error => {
                actionContext.telemetry.trace(error);
                actionContext.telemetry.trace('Unable to add invoices to cart');

                // Error object comes from API and doesn't have type definitions yet.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- No type definition for error.
                const errorDetails: CommerceException = error.data;
                const errorResult: ICartActionResultWithCart = { cart: undefined, status: 'FAILED', errorDetails };
                return errorResult;
            });
    }
    actionContext.telemetry.warning('Unable to add invoices, Cart Version could not be found');

    return { cart: undefined, status: 'FAILED', substatus: 'NOCARTVERSION' };
}
